<template>
  <v-card class="mx-auto" :disabled="loading" :loading="loading">
    <v-toolbar flat dense>
      <v-toolbar-title>
        <span class="text-h6" v-text="title" />
      </v-toolbar-title>

      <v-spacer />

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            fab
            x-small
            color="info"
            :loading="faqs_ldg"
            :disabled="faqs.length === 0"
            @click.stop="faqs_dlg = true"
          >
            <v-icon>mdi-help</v-icon>
          </v-btn>
        </template>
        <span>Ayuda</span>
      </v-tooltip>
    </v-toolbar>

    <v-divider />

    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="3">
          <v-select
            v-model="search.dispatched"
            :items="dispatched_options"
            :item-text="(item) => item.value"
            item-value="id"
            label="Estado"
            dense
            outlined
            hide-details
            :disabled="hasItems"
          />
        </v-col>

        <v-col v-if="login.role_id !== 13" cols="12" md="3">
          <v-select
            v-model="search.type"
            :items="type_options"
            :item-text="(item) => item.value"
            item-value="id"
            label="Tipo"
            dense
            outlined
            hide-details
            :disabled="hasItems"
            @change="search.enrollment = ''"
          />
        </v-col>

        <v-col v-if="search.type === 1" cols="12" md="3">
          <v-text-field
            v-model="search.enrollment"
            label="ID SM"
            dense
            outlined
            hide-details
            :disabled="hasItems"
            @keyup.enter="servicePharmacySearch"
          />
        </v-col>

        <v-col
          v-if="search.dispatched === 1 && search.type === 0"
          cols="12"
          md="3"
        >
          <DatePicker
            label="F. Carta inicio"
            :model.sync="search.start_date"
            :disabled="hasItems"
          />
        </v-col>

        <v-col
          v-if="search.dispatched === 1 && search.type === 0"
          cols="12"
          md="3"
        >
          <DatePicker
            label="F. final"
            :model.sync="search.end_date"
            :disabled="hasItems"
          />
        </v-col>

        <v-col cols="12">
          <v-btn
            v-if="!hasItems"
            block
            small
            color="primary"
            :loading="loading"
            :disabled="!canSearch"
            @click="servicePharmacySearch"
          >
            Buscar
            <v-icon right>mdi-magnify</v-icon>
          </v-btn>

          <v-btn v-else block small color="secondary" @click="clearItems">
            Cambiar parámetros
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense class="mt-2">
        <v-col v-if="dispatch_alert" cols="12">
          <v-alert v-model="dispatch_alert" type="info" dense dismissible>
            <v-row dense align="center">
              <v-col cols="12" md="9">
                <div
                  class="text-center text-md-left"
                  v-text="dispatch_alert_msg"
                />
              </v-col>

              <v-col
                v-if="login.permissions.rss.read && dispatch_rs_id"
                cols="12"
                md="3"
                class="text-center text-md-right"
              >
                <v-btn
                  small
                  color="primary"
                  :to="{
                    name: 'servicios.cartas',
                    params: { id: dispatch_rs_id },
                  }"
                >
                  Ver servicio
                  <v-icon small right>mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="table_search"
            label="Buscar en la tabla"
            dense
            outlined
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
          />
        </v-col>

        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="data"
            :loading="loading"
            :items-per-page="15"
            :search="table_search"
            dense
            class="elevation-1"
            no-data-text="No hay recetas para mostrar"
            loading-text="Cargando recetas..."
          >
            <template v-slot:item.folio="{ item }">
              <strong v-text="item.folio" />
            </template>

            <template v-slot:item.dispatch="{ item }">
              <v-chip
                x-small
                :color="item.dispatch ? 'success' : 'warning'"
                dark
              >
                {{ item.dispatch ? "Surtida" : "Pendiente" }}
              </v-chip>
            </template>

            <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    fab
                    x-small
                    color="warning"
                    :href="`${url_pdf}/carta/servicios/${item.rs_service_id}`"
                    target="_blank"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Ver receta</span>
              </v-tooltip>

              <v-tooltip v-if="canDispatch(item)" left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    fab
                    x-small
                    color="primary"
                    class="ml-1"
                    @click="dispatchStart(item)"
                  >
                    <v-icon>mdi-check-all</v-icon>
                  </v-btn>
                </template>
                <span>Surtir receta</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>

    <v-dialog v-model="dispatch_dlg" persistent max-width="520px">
      <v-card :disabled="dispatch_ldg" :loading="dispatch_ldg">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Surtir receta</v-toolbar-title>

          <v-spacer />

          <v-btn icon dark @click="closeDispatchDlg">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-form ref="dispatch_form_ref">
            <v-alert v-if="dispatch_item" dense outlined type="info">
              <div><strong>Folio:</strong> {{ dispatch_item.folio }}</div>
              <div>
                <strong>Asegurado:</strong> {{ dispatch_item.full_name }}
              </div>
            </v-alert>

            <v-autocomplete
              v-model="dispatch_form.provider_id"
              :items="pharmacies"
              item-value="id"
              item-text="trade_name"
              label="Farmacia"
              dense
              outlined
              clearable
              :loading="pharmacies_ldg"
              :rules="rules.required"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn small text @click="closeDispatchDlg">
            Cancelar
          </v-btn>

          <v-btn
            small
            color="primary"
            :loading="dispatch_ldg"
            @click="dispatchSubmit"
          >
            Surtir receta
            <v-icon small right>mdi-check-all</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";

import {
  URL_API,
  URL_PDF,
  dateTimeNow,
  headersToken,
  msgAlert,
  msgConfirm,
} from "../../control";

import { index } from "../../requests/pageRequest";

import DatePicker from "../../components/DatePicker.vue";
import FaqDlg from "../../components/FaqDlg.vue";

export default {
  components: {
    DatePicker,
    FaqDlg,
  },

  data() {
    return {
      api: "rss/pharmacy/dispacher",
      login: this.$store.getters.getLogin,
      url_pdf: URL_PDF,

      loading: false,

      data: [],
      table_search: "",

      headers: [
        {
          text: "Folio",
          value: "folio",
          filterable: true,
        },
        {
          text: "F. carta",
          value: "letter_generated",
          filterable: true,
        },
        {
          text: "ID SM",
          value: "enrollment",
          filterable: true,
        },
        {
          text: "Asegurado",
          value: "full_name",
          filterable: true,
        },
        {
          text: "Médico",
          value: "doctor",
          filterable: true,
        },
        {
          text: "F. carta",
          value: "letter_generated",
          filterable: true,
        },
        {
          text: "Observación",
          value: "caption",
          filterable: true,
        },
        {
          text: "Estado",
          value: "dispatch",
          filterable: false,
        },
        {
          text: "Farmacia",
          value: "provider_trade_name",
          filterable: true,
        },
        {
          text: "Acción",
          value: "action",
          sortable: false,
          filterable: false,
          align: "center",
        },
      ],

      type_options: [
        {
          id: 0,
          value: "TODOS",
        },
        {
          id: 1,
          value: "ASEGURADO",
        },
      ],

      dispatched_options: [
        {
          id: 0,
          value: "PENDIENTES",
        },
        {
          id: 1,
          value: "SURTIDAS",
        },
      ],

      search: {
        enrollment: "",
        start_date: "",
        end_date: "",
        dispatched: 0,
        type: 1,
      },

      dispatch_alert: false,
      dispatch_alert_msg: null,
      dispatch_rs_id: null,

      dispatch_dlg: false,
      dispatch_ldg: false,
      dispatch_item: null,

      dispatch_form: {
        provider_id: null,
      },

      pharmacies: [],
      pharmacies_ldg: false,

      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,

      rules: {
        required: [(v) => !!v || "Campo requerido"],
      },
    };
  },

  computed: {
    title() {
      const total = this.hasItems ? ` (${this.data.length})` : "";

      return `${this.$route.meta.title}${total}`;
    },

    hasItems() {
      return this.data.length > 0;
    },

    canSearch() {
      if (this.search.type === 1 && this.search.enrollment === "") {
        return false;
      }

      return true;
    },
  },

  methods: {
    isAdmin() {
      return [1, 2].includes(parseInt(this.login.role_id));
    },

    canDispatch(item) {
      return this.login.permissions.rs_pharmacies.update && !item.dispatch;
    },

    clearItems() {
      this.data = [];
      this.table_search = "";
      this.dispatch_alert = false;
      this.dispatch_alert_msg = null;
      this.dispatch_rs_id = null;
    },

    servicePharmacySearch() {
      this.loading = true;
      this.table_search = "";

      index(this.api, this.login.token, [
        {
          name: "id",
          value: this.login.id,
        },
        {
          name: "enrollment",
          value: this.search.enrollment === "" ? null : this.search.enrollment,
        },
        {
          name: "start_date",
          value: this.search.start_date,
        },
        {
          name: "end_date",
          value: this.search.end_date,
        },
        {
          name: "dispatched",
          value: this.search.dispatched,
        },
      ])
        .then((res) => {
          this.data = res.data;
        })
        .catch((err) => {
          console.log(err);

          this.$swal.fire(msgAlert("error", "Error al consultar las recetas"));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    dispatchStart(item) {
      if (this.isAdmin()) {
        this.dispatch_item = item;
        this.dispatch_form.provider_id = null;
        this.dispatch_dlg = true;

        if (this.pharmacies.length === 0) {
          this.getPharmacies();
        }

        return;
      }

      this.dispatchConfirm(item);
    },

    closeDispatchDlg() {
      this.dispatch_dlg = false;
      this.dispatch_item = null;
      this.dispatch_form.provider_id = null;
    },

    getPharmacies() {
      this.pharmacies_ldg = true;

      Axios.get(
        `${URL_API}/providers/pharmacies`,
        headersToken(this.login.token),
      )
        .then((res) => {
          this.pharmacies = res.data.success ? res.data.data : [];

          if (!res.data.success) {
            this.$swal.fire(msgAlert("error", res.data.message));
          }
        })
        .catch((err) => {
          console.log(err);

          this.$swal.fire(
            msgAlert("error", "Error al consultar las farmacias"),
          );
        })
        .finally(() => {
          this.pharmacies_ldg = false;
        });
    },

    dispatchSubmit() {
      if (!this.$refs.dispatch_form_ref.validate()) {
        return;
      }

      this.dispatchConfirm(this.dispatch_item);
    },

    dispatchConfirm(item) {
      this.$swal
        .fire(
          msgConfirm(
            `¿Confirma surtir la receta ${item.folio} para el asegurado ${item.full_name}?`,
          ),
        )
        .then((res) => {
          if (res.isConfirmed) {
            this.dispatchSave(item);
          }
        });
    },

    dispatchSave(item) {
      this.loading = true;
      this.dispatch_ldg = true;
      this.dispatch_alert = false;
      this.dispatch_alert_msg = null;
      this.dispatch_rs_id = null;

      Axios.post(
        `${URL_API}/${this.api}`,
        {
          id: item.id,
          dispatched_by_id: this.login.id,
          provider_id: this.isAdmin() ? this.dispatch_form.provider_id : null,
          folio: item.folio,
        },
        headersToken(this.login.token),
      )
        .then((res) => {
          this.$swal.fire(
            msgAlert(res.data.success ? "success" : "error", res.data.message),
          );

          if (res.data.success) {
            this.closeDispatchDlg();

            this.dispatch_alert = true;
            this.dispatch_alert_msg = res.data.message;
            this.dispatch_rs_id = res.data.data.rs_id;
            this.servicePharmacySearch();
          } else {
            console.log(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);

          this.$swal.fire(msgAlert("error", "Error al surtir la receta"));
        })
        .finally(() => {
          this.loading = false;
          this.dispatch_ldg = false;
        });
    },

    getFaqs() {
      this.faqs_ldg = true;

      Axios.get(
        `${URL_API}/faqs/faq_interfaces/${this.$route.meta.title}`,
        headersToken(this.login.token),
      )
        .then((resp) => {
          this.faqs = resp.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.faqs_ldg = false;
        });
    },

    setDefaultDates() {
      this.search.start_date = `${dateTimeNow().substring(0, 8)}01`;
      this.search.end_date = dateTimeNow().substring(0, 10);
    },
  },

  mounted() {
    this.getFaqs();
    this.setDefaultDates();
  },
};
</script>
